/**
 * ***********************
 * Billing Routes Components *
 * ***********************
 */
const Billing = () => import('@/components/Organisations/Billing/Billing');
const BillingSummary = () =>
  import('@/components/Organisations/Billing/Summary');
const BillingPayments = () =>
  import('@/components/Organisations/Billing/Transactions');
export default {
  title: 'Billing and Plans',
  link: '/configuration/billing',

  permission: [
    {
      action: 'view',
      entity: 'subscription',
    },
    {
      action: 'manage',
      entity: 'subscription',
    },
    {
      action: 'view',
      entity: 'child_subscription',
      type: 'dynamic',
    },
    {
      action: 'manage',
      entity: 'child_subscription',
      type: 'dynamic',
    },
  ],

  path: 'billing',
  component: Billing,
  redirect: 'billing/summary',
  meta: {
    permission: [
      {
        action: 'view',
        entity: 'subscription',
      },
      {
        action: 'manage',
        entity: 'subscription',
      },
      {
        action: 'view',
        entity: 'child_subscription',
        type: 'dynamic',
      },
      {
        action: 'manage',
        entity: 'child_subscription',
        type: 'dynamic',
      },
    ],
    validateSomePermissions: true,
    id: 'configuration__billing-and-plans-tab',
  },
  children: [
    {
      path: 'summary',
      component: BillingSummary,
      permission: [
        {
          action: 'view',
          entity: 'subscription',
        },
        {
          action: 'manage',
          entity: 'subscription',
        },
        {
          action: 'view',
          entity: 'child_subscription',
          type: 'dynamic',
        },
        {
          action: 'manage',
          entity: 'child_subscription',
          type: 'dynamic',
        },
      ],
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'subscription',
          },
          {
            action: 'manage',
            entity: 'subscription',
          },
          {
            action: 'view',
            entity: 'child_subscription',
            type: 'dynamic',
          },
          {
            action: 'manage',
            entity: 'child_subscription',
            type: 'dynamic',
          },
        ],
        validateSomePermissions: true,
        id: 'configuration__billing-and-plan__summary-tab',
      },
    },
    {
      path: 'payments',
      component: BillingPayments,
      permission: [
        {
          action: 'view',
          entity: 'subscription',
        },
        {
          action: 'manage',
          entity: 'subscription',
        },
        {
          action: 'view',
          entity: 'child_subscription',
          type: 'dynamic',
        },
        {
          action: 'manage',
          entity: 'child_subscription',
          type: 'dynamic',
        },
      ],
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'subscription',
          },
          {
            action: 'manage',
            entity: 'subscription',
          },
          {
            action: 'view',
            entity: 'child_subscription',
            type: 'dynamic',
          },
          {
            action: 'manage',
            entity: 'child_subscription',
            type: 'dynamic',
          },
        ],
        validateSomePermissions: true,
        id: 'configuration__billing-and-plan__payments-tab',
      },
    },
  ],
};
